export const isObject = value => typeof value === 'object' && value !== null;
export const isString = value => typeof value === 'string';